import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, renderSlot as _renderSlot, vModelText as _vModelText, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "d-flex justify-content-end mb-3"
}
const _hoisted_2 = { class: "mr-2" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("strong", null, "Montant total : ", -1)
const _hoisted_4 = { class: "badge badge-success" }
const _hoisted_5 = { class: "card" }
const _hoisted_6 = { class: "card-header d-flex" }
const _hoisted_7 = { class: "mr-2" }
const _hoisted_8 = ["value"]
const _hoisted_9 = { class: "mr-2" }
const _hoisted_10 = ["id"]
const _hoisted_11 = {
  key: 0,
  class: "spinner-border spinner-border-sm",
  role: "status",
  "aria-hidden": "true"
}
const _hoisted_12 = {
  key: 1,
  class: "fa fa-refresh"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", null, " Actualiser", -1)
const _hoisted_14 = {
  key: 0,
  class: "mx-2"
}
const _hoisted_15 = { class: "form-inline" }
const _hoisted_16 = { class: "form-group mr-1" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-close" }, null, -1)
const _hoisted_18 = {
  key: 1,
  class: "ml-auto"
}
const _hoisted_19 = { class: "card-body p-0" }
const _hoisted_20 = {
  key: 1,
  class: "p-2"
}
const _hoisted_21 = { key: 2 }
const _hoisted_22 = {
  key: 0,
  class: "card-footer d-flex justify-content-end"
}
const _hoisted_23 = { class: "col-3 mr-2 bg-dark text-white rounded" }
const _hoisted_24 = { class: "col-3 bg-success text-white rounded" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProgressBar = _resolveComponent("ProgressBar")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (this.showTotalMontant === true)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _createElementVNode("span", _hoisted_4, _toDisplayString(new Intl.NumberFormat('de-DE').format(_ctx.total_montant)) + " FCFA", 1)
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.rows) = $event)),
            class: "form-control"
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.showEntries, (option) => {
              return (_openBlock(), _createElementBlock("option", {
                key: option,
                value: option,
                onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.refreshSlot()))
              }, _toDisplayString(option), 41, _hoisted_8))
            }), 128))
          ], 512), [
            [_vModelSelect, _ctx.rows]
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("button", {
            id: 'refresh'+this.table,
            class: "btn btn-outline-dark mr-2",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.getDatas()))
          }, [
            (_ctx.isLoading == true)
              ? (_openBlock(), _createElementBlock("span", _hoisted_11))
              : (_openBlock(), _createElementBlock("i", _hoisted_12)),
            _hoisted_13
          ], 8, _hoisted_10)
        ]),
        _renderSlot(_ctx.$slots, "datatable_header_btns"),
        (this.period_filter === true)
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
              _createElementVNode("form", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _withDirectives(_createElementVNode("input", {
                    type: "month",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.period) = $event)),
                    class: "form-control",
                    required: "",
                    onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.getDatas()))
                  }, null, 544), [
                    [_vModelText, _ctx.period]
                  ])
                ]),
                (this.period != this.currentPeriod)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      type: "button",
                      class: "btn btn-secondary",
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.resetPeriod()))
                    }, [
                      _hoisted_17,
                      _createTextVNode(" Reinitialiser ")
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true),
        (this.affichage == 'list' || this.affichage == undefined)
          ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
              _withDirectives(_createElementVNode("input", {
                type: "search",
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.filters['global'].value) = $event)),
                class: "form-control",
                placeholder: "Rechercher"
              }, null, 512), [
                [_vModelText, _ctx.filters['global'].value]
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_19, [
        (_ctx.isLoading === true)
          ? (_openBlock(), _createBlock(_component_ProgressBar, {
              key: 0,
              mode: "indeterminate",
              style: {"height":"6px"}
            }))
          : _createCommentVNode("", true),
        (this.affichage == 'card')
          ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
              _renderSlot(_ctx.$slots, "datacards_body", {
                key: _ctx.key,
                datas: _ctx.datas,
                rows: _ctx.rows,
                showEntries: _ctx.showEntries,
                filters: _ctx.filters
              })
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_21, [
              _renderSlot(_ctx.$slots, "datatable_body", {
                key: _ctx.key,
                datas: _ctx.datas,
                rows: _ctx.rows,
                showEntries: _ctx.showEntries,
                filters: _ctx.filters
              })
            ]))
      ]),
      (this.solde === true)
        ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
            _createElementVNode("div", _hoisted_23, " Total débit : " + _toDisplayString(new Intl.NumberFormat('de-DE').format(_ctx.total_debit)) + " FCFA ", 1),
            _createElementVNode("div", _hoisted_24, " Total crédit : " + _toDisplayString(new Intl.NumberFormat('de-DE').format(_ctx.total_credit)) + " FCFA ", 1)
          ]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}